import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n";
import useSmoothScroll from "@/hooks/useSmoothScroll";
import Home from "@/pages/Home";
import Booking from "@/pages/Booking";
import ServicePage from "@/pages/ServicePage";
import FloatingContact from "@/components/FloatingContact";

function App() {
  useSmoothScroll();
  return (
    <HelmetProvider>
      <LanguageProvider>
        <BrowserRouter>
          <div className="grain" />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services/:id" element={<ServicePage />} />
            <Route path="/book" element={<Booking />} />
          </Routes>
          <FloatingContact />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
